// field_key_empty_number!= number; // this key uses only as stub for other keys

/*
 * To implement hint you need implement following parts=
 * 1. trigger
 * 2. shortcut
 * 3. view
 */
export enum EShortcutType {
  STUB = 'stub',
  SHORTCUT_HINTS_VISIBILITY = 'shortcut_hints_visibility',
  /*
   * COLLECTIONS
   */

  COLLECTIONS_CREATE = 'shortcut_collections_create', //t s u v

  /*
   * GENERATION
   */
  GENERATION_SETTINGS_IMAGE_CANVAS_PASTE_IMAGE = 'shortcut_generation_settings_image_canvas_paste_image', //t s u v
  GENERATION_START = 'shortcut_generation_start', //t s u v
  GENERATION_START_WITH_NEW_SEEDS = 'shortcut_generation_start_with_new_seeds', //? ? ? ?
  GENERATION_CONTINUE = 'shortcut_generation_continue', //t s u v
  GENERATION_COMMIT = 'shortcut_generation_commit', //t s u v
  GENERATION_STOP = 'shortcut_generation_stop', //t s u v
  GENERATION_NAME_EDIT_START = 'shortcut_generation_name_edit_start', //t s - v

  /*
   * GRID2D
   */
  GRID2D_CELL_BUTTON_COPY_TO_CLIPBOARD = 'shortcut_grid2d_cell_button_copy_to_clipboard', //t s u v
  GRID2D_CELL_OPEN_FULLSCREEN_IMAGE = 'shortcut_grid2d_cell_open_fullscreen_image', //t s u v
  GRID2D_BAR_DECREASE_CELL_SIZE = 'shortcut_grid2d_bar_decrease_cell_size', //t s u v
  GRID2D_CHANGE_CELL_SIZE_WITH_SCROLL = 'shortcut_grid2d_change_cell_size_with_scroll', //t s u v

  /*
   *  FULLSCREEN GRID2D
   */
  FULLSCREEN_GRID2D_CLOSE = 'hint_keyboard_fullscreen_grid2d_close', //t s u v

  /*
   *  FULLSCREEN IMAGE
   */
  FULLSCREEN_GRID2D_IMAGE_CLOSE = 'hint_keyboard_fullscreen_grid2d_image_close', //t s u v
  FULLSCREEN_GRID2D_IMAGE_NAVIGATION_BY_KEYS = 'hint_keyboard_fullscreen_grid2d_image_navigation_by_keys', //t s - v
  FULLSCREEN_GRID2D_IMAGE_NAVIGATION_BY_SCROLL = 'hint_keyboard_fullscreen_grid2d_image_navigation_by_scroll', //t ? - v

  /*
   *  FULLSCREEN IMAGE CANVAS
   */
  FULLSCREEN_IMAGE_CANVAS_CLOSE = 'hint_keyboard_fullscreen_image_canvas_close', //t s u v
  FULLSCREEN_IMAGE_CANVAS_CROP_BOX_MAXIMIZE = 'hint_keyboard_fullscreen_image_canvas_crop_box_maximize', //t s - v

  /*
   * INPUT
   */
  INPUT_WITH_BUTTON_EDIT_END = 'shortcut_input_with_button_edit_end', //t s u v

  /*
   * NAVIGATION
   */
  NAVIGATION_HOTKEYS_BETWEEN_PAGES = 'shortcut_navigation_hotkeys_between_pages', // t s u v
  NAVIGATION_HOTKEYS_BETWEEN_WORKSPACES = 'shortcut_navigation_hotkeys_between_workspaces', //t s u v

  /*
   * SLIDER
   */
  SLIDER_DECREASE_STEP = 'hint_keyboard_slider_decrease_step', //t s u v

  /*
   * USER TASK
   */
  USER_TASK_CREATE = 'shortcut_user_tasks_create', //t s u v
}
